module.exports = __webpack_public_path__ + "components/wave-graph-scale/static/imperial-ad2f1a04dbd2aae0c0b3719ebc298dcb.svg";